import { render, staticRenderFns } from "./DistributionSettingsComponent.vue?vue&type=template&id=ba8543da&scoped=true&"
import script from "./DistributionSettingsComponent.vue?vue&type=script&lang=js&"
export * from "./DistributionSettingsComponent.vue?vue&type=script&lang=js&"
import style0 from "./DistributionSettingsComponent.vue?vue&type=style&index=0&id=ba8543da&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba8543da",
  null
  
)

export default component.exports